import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';

export function RoleDescriptions({ open, handleClose }) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='lg'
      fullWidth
      disableScrollLock
    >
      <DialogTitle>Role Descriptions</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <iframe
            title='roles'
            src='/roleDescriptions.html'
            width='100%'
            height='375'
          ></iframe>
        </DialogContentText>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
